var classof = require('../internals/classof');

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String(argument);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/to-string.js
// module id = 76
// module chunks = 1